import * as types from './types'

export default {
  [types.SET_FIRST_CATEGORIES](state, categories1) {
    state.categories1 = categories1 || []
  },
  [types.SET_SECOND_CATEGORIES](state, categories2) {
    state.categories2 = categories2 || []
  },
  [types.RESET_SECOND_CATEGORIES](state) {
    state.categories2 = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/category/mutations.js